module.exports = __webpack_public_path__ + "img/wired_game_explanation_splash.d1d19c77.jpg";